import axiosApiClient from '..';
import { handleError, throwErrorIfWrongStatus } from './utils';

const BASE_URL = 'api/telescope/feed';

class FeedServiceClass {
  getFeed = async (limit, cursor) => {
    try {
      const params = new URLSearchParams();

      if (limit) {
        params.append('limit', limit);
      }
      if (cursor) {
        params.append('cursor', cursor);
      }

      const query = params.toString();
      const response = await axiosApiClient.get(query ? `${BASE_URL}?${query}` : BASE_URL);

      throwErrorIfWrongStatus(response, 200);

      const { data, pagination } = response.data.data;

      return { data, pagination };
    } catch (err) {
      throw handleError(err, 'Error occurred while fetching feed.');
    }
  };

  getTrendingFeed = async ({ limit, cursor, seed, phase, excludedFeedItems } = {}) => {
    try {
      const params = new URLSearchParams();

      if (limit) {
        params.append('limit', limit);
      }
      if (cursor) {
        params.append('cursor', cursor);
      }
      if (seed) {
        params.append('seed', seed);
      }
      if (phase) {
        params.append('phase', phase);
      }

      const query = params.toString();
      const response = await axiosApiClient.post(
        query ? `${BASE_URL}/trending?${query}` : `${BASE_URL}/trending`,
        { excludedFeedItems: excludedFeedItems || [] },
      );

      throwErrorIfWrongStatus(response, 200);

      const { data, pagination } = response.data.data;

      return { data, pagination };
    } catch (err) {
      throw handleError(err, 'Error occurred while fetching trending feed.');
    }
  };

  likeFeedItem = async feedItemId => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}/${feedItemId}/like`, {});

      throwErrorIfWrongStatus(response, 201);

      return response.data;
    } catch (err) {
      throw handleError(err, 'Error occurred while liking the feed item.');
    }
  };

  unlikeFeedItem = async feedItemId => {
    try {
      const response = await axiosApiClient.delete(`${BASE_URL}/${feedItemId}/like`);

      throwErrorIfWrongStatus(response, 200);

      return response.data;
    } catch (err) {
      throw handleError(err, 'Error occurred while unliking the feed item.');
    }
  };

  shareFeedItem = async (feedItemId, platform) => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}/${feedItemId}/share`, platform ? { platform } : {});

      throwErrorIfWrongStatus(response, 201);

      return response.data;
    } catch (err) {
      throw handleError(err, 'Error occurred while sharing the feed item.');
    }
  };

  createFeedComment = async (feedItemId, text) => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}/${feedItemId}/comments`, { text });

      throwErrorIfWrongStatus(response, 201);

      const { comment } = response.data.data;

      return { comment };
    } catch (err) {
      throw handleError(err, 'Error occurred while creating the comment.');
    }
  };

  getFeedComments = async (feedItemId, limit, cursor) => {
    try {
      const params = new URLSearchParams();

      if (limit) {
        params.append('limit', limit);
      }
      if (cursor) {
        params.append('cursor', cursor);
      }

      const query = params.toString();
      const response = await axiosApiClient.get(
        query ? `${BASE_URL}/${feedItemId}/comments?${query}` : `${BASE_URL}/${feedItemId}/comments`,
      );

      throwErrorIfWrongStatus(response, 200);

      const { data, pagination } = response.data.data;

      return { data, pagination };
    } catch (err) {
      throw handleError(err, 'Error occurred while fetching feed comments.');
    }
  };

  createFeedReply = async (feedCommentId, text) => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}/${feedCommentId}/replies`, { text });

      throwErrorIfWrongStatus(response, 201);

      const { comment } = response.data.data;

      return { comment };
    } catch (err) {
      throw handleError(err, 'Error occurred while creating the reply.');
    }
  };

  getFeedReplies = async (feedCommentId, limit, cursor) => {
    try {
      const params = new URLSearchParams();

      if (limit) {
        params.append('limit', limit);
      }
      if (cursor) {
        params.append('cursor', cursor);
      }

      const query = params.toString();
      const response = await axiosApiClient.get(
        query ? `${BASE_URL}/${feedCommentId}/replies?${query}` : `${BASE_URL}/${feedCommentId}/replies`,
      );

      throwErrorIfWrongStatus(response, 200);

      const { data, pagination } = response.data.data;

      return { data, pagination };
    } catch (err) {
      throw handleError(err, 'Error occurred while fetching replies.');
    }
  };

  likeFeedComment = async feedCommentId => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}/comment/${feedCommentId}/like`, {});

      throwErrorIfWrongStatus(response, 201);

      return response.data;
    } catch (err) {
      throw handleError(err, 'Error occurred while liking the comment.');
    }
  };

  unlikeFeedComment = async feedCommentId => {
    try {
      const response = await axiosApiClient.delete(`${BASE_URL}/comment/${feedCommentId}/like`);

      throwErrorIfWrongStatus(response, 200);

      return response.data;
    } catch (err) {
      throw handleError(err, 'Error occurred while unliking the comment.');
    }
  };

  deleteFeedComment = async feedCommentId => {
    try {
      const response = await axiosApiClient.delete(`${BASE_URL}/${feedCommentId}`);

      throwErrorIfWrongStatus(response, 200);

      return response.data;
    } catch (err) {
      throw handleError(err, 'Error occurred while deleting the comment.');
    }
  };
}

const FeedService = new FeedServiceClass();
export default FeedService;
